import React from 'react';
import { FieldValues } from 'react-hook-form';
import type { GroupBase, SelectInstance } from 'react-select';

import { CreatableSelectField } from '@/components/UI/Fields/ReactFormFields/CreatableSelectField';
import { FieldProps } from '@/components/UI/Fields/types';
import { useMaterieelTypenSearch } from '@/hooks/useMaterieelTypenSearch';

type MaterieelTypenFieldProps<T extends FieldValues> = FieldProps<T> & {
  marginBottom?: number;
} & Omit<React.ComponentPropsWithoutRef<typeof CreatableSelectField>, keyof FieldProps<T>>;

export const MaterieelTypenSearchField = ({
  name,
  label = 'Materieeltype',
  testId = 'materieelTypen',
  placeholder = 'Voeg materieeltype(n) toe',
  createLabel = 'MaterieelType:',
  marginBottom = 0,
  control,
  defaultValue,
  onChangeCallback,
  ref,
  ...rest
}: MaterieelTypenFieldProps<any> & { ref?: React.Ref<SelectInstance<unknown, boolean, GroupBase<unknown>>> }) => {
  const { groupedOptions } = useMaterieelTypenSearch();

  return (
    <div style={{ marginBottom: `${marginBottom}px` }}>
      <CreatableSelectField
        ref={ref}
        label={label}
        enableSelectOneForMultiple
        control={control}
        testId={testId}
        defaultValue={defaultValue}
        createLabel={createLabel}
        isMulti
        isClearable
        isSearchable
        openMenuOnClick
        name={name}
        matchFromStart={false}
        prioritizeGroupsBySearchInput
        options={groupedOptions}
        placeholder={placeholder}
        onChangeCallback={onChangeCallback}
        {...rest}
      />
    </div>
  );
};
